import { render, staticRenderFns } from "./ReviewOrder.vue?vue&type=template&id=57c1a3b8&"
import script from "./ReviewOrder.vue?vue&type=script&lang=js&"
export * from "./ReviewOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ReviewOrder.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent/user/4158/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57c1a3b8')) {
      api.createRecord('57c1a3b8', component.options)
    } else {
      api.reload('57c1a3b8', component.options)
    }
    module.hot.accept("./ReviewOrder.vue?vue&type=template&id=57c1a3b8&", function () {
      api.rerender('57c1a3b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/steps/ReviewOrder.vue"
export default component.exports